export const PENDING = 'PENDING';
export const CANCELLED = 'REFUNDED';
export const SUCCESSFUL = 'DONE';
